import React, { useState } from 'react'
import Title from '../../../components/Title/Title';
import { Col, Container, Row } from 'react-bootstrap';
import EventCard from '../../../components/EventCard';
import Button from '../../../components/Button';
import SectionHeader from '../../../components/SectionHeader';
import './HowToBecomeMitra.scss'


function HowToBecomeMitra(props) {



    return (
        <>

            <div className="how-to-become-mitra">

            </div>
            <div className="container-fluid2 bg2 ">
                <Title options={{ "title": "How to Join EFH | Enroll in Online ICSE & CBSE Tuition", "description": "A step-by-step guide to joining EFH and starting online Computer Science tuition for ICSE and CBSE students of Class 9-12.", "image": "", "url": "" }} />

                <div className="container sectionheader ">


                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card p-3'>
                                <h2 className="text-center fw-bold mb-4" style={{ fontSize: "250%", lineHeight: "2" }}>How to become <span className="text-primary">Mitra</span></h2>
                                <ul className="" style={{ fontSize: "130%", lineHeight: "2" }}>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">STEP 1:</span> Register on the EFH website or application. Fill the form with personal details like name, phone number, age, address and more.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">STEP 2:</span> Create a sign in username and password.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">STEP 3:</span> Choose your subscription type.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">STEP 4:</span> Choose your payment plan and pay.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">STEP 5:</span> Receive a welcome email from EFH family.
                                    </li>
                                    <li>
                                        <span className="fw-bold text-primary">STEP 6:</span> Begin your course.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>




                     


                </div>
            </div>
        </>
    );
};


export default HowToBecomeMitra;
